<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;" width="350">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<v-col cols="12">
								<v-select
									v-model="item.imFt"
									:items="NbuFinTp"
									label="Тип установи"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									clearable
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.imNumIdent"
									label="Код ЄДРПОУ"
									outlined
									dense
									hide-details="auto"
									single-line
									clearable
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.ianFullName"
									label="Повне найменування"
									outlined
									dense
									hide-details="auto"
									single-line
									clearable
									:rules_="[rules.requiredAny]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.imSt"
									:items="NbuCompanyStatus"
									label="Стан"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									clearable
								></v-select>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<!-- <v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon large color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer> -->

		<v-container style="padding: 64px 0px 0px 356px;">
			<v-card flat>
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text>
					<v-data-table
						:items="items" 
						:headers="headers"
						hide-default-footer
						disable-pagination
					>
						<template v-slot:item.actions="{ item, index }">
							<v-toolbar flat dense color="transparent">
								<z-detail v-model="item" readonly fullscreen>
									<template v-slot:activator="props">
										<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-icon>mdi-eye</v-icon>
										</v-btn>
									</template>
								</z-detail>
							</v-toolbar>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>
	</v-main>
</template>


<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import zDetail from '@/views/dialogs/details/NbuFinancialInstitution'

export default {
	name: 'NbuFinancialInstitution',
	components: { zDetail },
	data: () => ({
		headline: "Державний реєстр фінансових установ",
		title: "Сервіс пошуку фінансових установ в державному реєстрі НБУ",
		subtitle: "Сервіс пошуку фінансових установ",
		icon: "mdi-leaf",

		filename: '',

		loading: false,

		item: {
			ftCat: 'R',
			imNumIdent: null,
			ianFullName: 'ПЗУ Україна',
			typeOfPerson: null,
			iabIsBadReputation: null,
			imCat: null,
			skFullName: null,
			skNumident: null,
			imSt: null,
		},

		items: [],

		headers: [
			{ value: "ianFullName", text: 'Найменування',  sortable: true },//: "ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО \"СТРАХОВА КОМПАНІЯ \"ПЗУ УКРАЇНА СТРАХУВАННЯ ЖИТТЯ\"",
			{ value: "ftName", text: 'Тип НФП',  sortable: true },//: "Страхова компанія",
			{ value: "imNumIdent", text: 'Код ЄДРПОУ',  sortable: true },//: "32456224",
			{ value: "icrDate", text: 'Дата внесення до реєстру',  sortable: true },//: "2004-08-21T00:00:00",
			{ value: "imStName", text: 'Стан',  sortable: true },//: "Включена до реєстру",
			{ value: "iaFull", text: 'Адреса',  sortable: true },//: "04053 КИЇВ, КИЇВ (МІСТО) КИЇВ 053, Cічових Стрільців, буд.42",
			{ value: "iaPhoneCode", text: 'Міжміський телефонний код',  sortable: true },//: "044",
			{ value: "iaPhone", text: 'Телефон',  sortable: true },//: "2386238",
			{ value: "iaEmail", text: 'E-mail',  sortable: true },//: "pzulife@pzu.com.ua",
			{ value: "indObl", text: 'Область',  sortable: true },//: "КИЇВ",
			{ value: "kName", text: 'ПІБ керівника',  sortable: true },//: "Шолига   Збігнев Кшиштоф",

			/* { value: "imId", text: '',  sortable: true },//: 20000033180,
			{ value: "imIh", text: '',  sortable: true },//: 30000001107832,
			{ value: "ianRoSeria", text: '',  sortable: true },//: "А01",
			{ value: "ianRoCode", text: '',  sortable: true },//: "623446",
			{ value: "ianRoDt", text: '',  sortable: true },//: "2003-04-08T00:00:00",
			{ value: "filialsCount", text: '',  sortable: true },//: 0,
			{ value: "imSt", text: '',  sortable: true },//: "A",
			{ value: "imFt", text: '',  sortable: true },//: 3,
			{ value: "ftCat", text: '',  sortable: true },//: "R",
			{ value: "imCat", text: '',  sortable: true },//: "U",
			{ value: "iabIsBadReputation", text: '',  sortable: true },//: null,
			{ value: "typeOfPerson", text: '',  sortable: true },//: null,
			{ value: "agentFullName", text: '',  sortable: true },//: null,
			{ value: "pibKerRealiz", text: '',  sortable: true },//: null */

			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),

	props: {
		variant: 	{ type: String, default: 'outlined' },
		density: 	{ type: String, default: null },
	},

	computed: {
		//...mapGetters('Loss', [ 'param', 'data' ]),
		...mapGetters('NbuFinTp', { NbuFinTp: 'items' }),
		...mapGetters('NbuCompanyStatus', { NbuCompanyStatus: 'items' }),
		/* ...mapGetters('NbuBool', { NbuBool: 'items' }),
		...mapGetters('NbuFintpCat', { NbuFintpCat: 'items' }),
		...mapGetters('NbuInsurCat', { NbuInsurCat: 'items' }),
		...mapGetters('NbuPersonPublic', { NbuPersonPublic: 'items' }), */

		rules() {
			return {
				required: (value) => !!value || this.$vuetify.locale.t('$vuetify.rule.required'),
				requiredAny: (value) => !!this.param.ident_code || !!this.param.plate_no || !!this.param.vin || 'Хоча б одне з полів повинно бути заповнене',
			}
		},
	},

	created() {
		//console.log(this.$options.name, 'vcreated')

		/* let access_token = localStorage.getItem('M-Api-Key')
		if(access_token) {
			axios.defaults.headers.common['M-Api-Key'] = access_token;
		}

		let token = localStorage.getItem('X-Api-Key')
		if(token) {
			//console.log(this.$options.name,'created', 'token', token)
			axios.defaults.headers.common['X-Api-Key'] = token;
			this.setLogin(true)
		} else {
			this.setLogin(false)
			this.$router.push({ name: 'Login' }).catch(err => {})
		}

		this.param.policy_type  = 'ALL'; */
	},

	methods: {
		...mapActions(['setLogin', 'showMessage']),
		//...mapActions('Loss', ['setData']),

		onClear() {
			this.item = { ftCat: 'R' }
		},

		onOK() {
			//console.log(this.$options.name, 'onOK','item', this.item)

			var that = this
			if(this.$refs.form.validate()) {
				this.loading = true
				axios.post(`/nbu/kis/PublicInfo/MainInsurerList`, this.item).then(response => {
					console.log(that.$options.name, 'onSearch','response.data', response.data)

					that.items = response.data
				}, error => {
					console.log('error', error)
					this.showMessage(error)
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onExcel() {
			//console.log(this.$options.name,  'onCard', 'direction', direction) 

			const workbook = XLSX.utils.book_new();

			const worksheet = XLSX.utils.json_to_sheet(this.oscpv);
			XLSX.utils.book_append_sheet(workbook, worksheet, 'OSCPV');

			const worksheet2 = XLSX.utils.json_to_sheet(this.gc);
			XLSX.utils.book_append_sheet(workbook, worksheet2, 'GC');

			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
			saveAs(blob, this.filename + '.xlsx');
		}
	},
}
</script>
